import { TEXTOS } from '../../manual-textos';
import { ou } from '../../manual-utils';
import {
  blocoTexto,
} from '../blocos';
import type { Bloco } from '../blocos';
import type { ManualData } from '../../manual-types';

export function capituloIntroducao(dados: ManualData): Bloco[] {
  const maquina = ou(dados.nomeMaquina, 'máquina');
  return [
    {
      id: 'introducao',
      peso: 6,
      novaPagina: true,
      entrada: { nivel: 1, rotulo: 'Introdução' },
      conteudo: <h3 className="manual-titulo-solto">INTRODUÇÃO</h3>,
    },
    ...blocoTexto(
      `${TEXTOS.introducao.replace('o equipamento', `a ${maquina.toLowerCase()}`)}`,
      'intro-1',
    ),
    ...blocoTexto(TEXTOS.introducaoComplemento, 'intro-2'),
  ];
}
